var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "roles.create",
              expression: "'roles.create'",
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { 400: true },
            },
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew },
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" },
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew"))),
          ]),
        ],
        1
      ),
      _c("Grid", {
        ref: "grid",
        attrs: { service: _vm.service, route_name: "roles" },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function (actions) {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-row gap-2" },
                  [
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "roles.edit",
                          expression: "`roles.edit`",
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Editar grupo",
                            delay: { show: 100, hide: 100 },
                          },
                          expression:
                            "{\n            content: 'Editar grupo',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true },
                        },
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EditIcon" },
                      on: {
                        click: function ($event) {
                          return _vm.edit(actions.row.id)
                        },
                      },
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Clonar grupo",
                            delay: { show: 100, hide: 100 },
                          },
                          expression:
                            "{\n            content: 'Clonar grupo',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true },
                        },
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-primary",
                      attrs: { icon: "CopyIcon" },
                      on: {
                        click: function ($event) {
                          return _vm.confirmClone(actions.row.id)
                        },
                      },
                    }),
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "roles.delete",
                          expression: "`roles.delete`",
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top",
                          value: {
                            content: "Excluir grupo",
                            delay: { show: 100, hide: 100 },
                          },
                          expression:
                            "{\n            content: 'Excluir grupo',\n            delay: { show: 100, hide: 100 }\n          }",
                          modifiers: { top: true },
                        },
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                      attrs: { icon: "Trash2Icon" },
                      on: {
                        click: function ($event) {
                          return _vm.destroy(actions.row)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }